import createApiThunk from '../../../ApplicationFactory'
import { type IUser } from '../../../models/User'

export const getUserProfileApi = createApiThunk<IUser>('getUserProfileApi', {
  url: '/api/users/profile',
  method: 'GET'
})
